/* GoldenLove header — mobile panel and dropdown behaviour.
   Small enough to stay inline-simple; no dependency on Dawn's header JS. */

(function () {
  'use strict';

  /* Publish the pill's real height so other templates can reserve exactly that
     much room. Measured rather than hard-coded: the pill grows with the logo
     width setting, the CTA label, and the display font swapping in. */
  function syncHeight() {
    var bar = document.querySelector('.voffen-headerbar');
    if (!bar) return;
    var h = Math.round(bar.getBoundingClientRect().height);
    if (h > 0) {
      document.documentElement.style.setProperty('--voffen-header-h', h + 'px');
    }
  }

  function watchHeight() {
    syncHeight();
    window.addEventListener('resize', syncHeight, { passive: true });
    window.addEventListener('load', syncHeight);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(syncHeight);

    var bar = document.querySelector('.voffen-headerbar');
    if (bar && 'ResizeObserver' in window) {
      new ResizeObserver(syncHeight).observe(bar);
    }
  }

  function init() {
    watchHeight();

    var burger = document.querySelector('.voffen-header__burger');
    var panel = document.getElementById('VoffenHeaderMenu');

    if (burger && panel) {
      burger.addEventListener('click', function () {
        var open = burger.getAttribute('aria-expanded') === 'true';
        burger.setAttribute('aria-expanded', String(!open));
        panel.hidden = open;
      });

      panel.addEventListener('click', function (event) {
        if (!event.target.closest('a')) return;
        burger.setAttribute('aria-expanded', 'false');
        panel.hidden = true;
      });
    }

    var dropdowns = document.querySelectorAll('.voffen-dropdown');

    // Only one dropdown open at a time.
    dropdowns.forEach(function (details) {
      details.addEventListener('toggle', function () {
        if (!details.open) return;
        dropdowns.forEach(function (other) {
          if (other !== details) other.open = false;
        });
      });
    });

    document.addEventListener('click', function (event) {
      dropdowns.forEach(function (details) {
        if (details.open && !details.contains(event.target)) details.open = false;
      });
    });

    document.addEventListener('keyup', function (event) {
      if (event.key !== 'Escape') return;
      dropdowns.forEach(function (details) {
        details.open = false;
      });
      if (burger && panel && burger.getAttribute('aria-expanded') === 'true') {
        burger.setAttribute('aria-expanded', 'false');
        panel.hidden = true;
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
